export enum RedoShopifyOrderDisplayFinancialStatus {
  /** Displayed as **Authorized**. */
  Authorized = "AUTHORIZED",
  /** Displayed as **Expired**. */
  Expired = "EXPIRED",
  /** Displayed as **Paid**. */
  Paid = "PAID",
  /** Displayed as **Partially paid**. */
  PartiallyPaid = "PARTIALLY_PAID",
  /** Displayed as **Partially refunded**. */
  PartiallyRefunded = "PARTIALLY_REFUNDED",
  /** Displayed as **Pending**. */
  Pending = "PENDING",
  /** Displayed as **Refunded**. */
  Refunded = "REFUNDED",
  /** Displayed as **Voided**. */
  Voided = "VOIDED",
}

export const displayFinancialStatusLabels: Record<
  RedoShopifyOrderDisplayFinancialStatus,
  string
> = {
  [RedoShopifyOrderDisplayFinancialStatus.Authorized]: "Authorized",
  [RedoShopifyOrderDisplayFinancialStatus.Expired]: "Expired",
  [RedoShopifyOrderDisplayFinancialStatus.Paid]: "Paid",
  [RedoShopifyOrderDisplayFinancialStatus.PartiallyPaid]: "Partially paid",
  [RedoShopifyOrderDisplayFinancialStatus.PartiallyRefunded]:
    "Partially refunded",
  [RedoShopifyOrderDisplayFinancialStatus.Pending]: "Pending",
  [RedoShopifyOrderDisplayFinancialStatus.Refunded]: "Refunded",
  [RedoShopifyOrderDisplayFinancialStatus.Voided]: "Voided",
};

const displayFinancialStatusValues: ReadonlySet<string> = new Set(
  Object.values(RedoShopifyOrderDisplayFinancialStatus),
);

export function isDisplayFinancialStatus(
  value: string,
): value is RedoShopifyOrderDisplayFinancialStatus {
  return displayFinancialStatusValues.has(value);
}
